<template>
  <div>
    <div class="title-h3 mr-b20">보고서 정보 확인</div>
    <div class="list form-list mr-b25">
      <div class="title-bar title-h4 tit">기본 정보</div>
      <el-form :model="reportBasicInfo" label-width="120px">
        <el-form-item label="보고서명">{{ reportBasicInfo.reportName }}</el-form-item>
        <el-form-item label="보고서 설명">{{ reportBasicInfo.reportContents }}</el-form-item>
        <el-form-item label="보고서 타입">{{ periodType[reportBasicInfo.periodType] }}</el-form-item>
        <el-form-item v-if="reportBasicInfo.periodType === 'C'" label="기준 기간">
          {{ getPeriodDate(reportBasicInfo.periodConfSet) }}
        </el-form-item>
      </el-form>
    </div>
    <div v-if="reportBasicInfo.periodType !== 'C'" class="list form-list mr-b20">
      <div class="title-bar title-h4 tit">스케줄링</div>
      <el-form :model="reportBasicInfo" label-width="120px">
        <el-form-item label="자동생성 여부">{{ reportBasicInfo.autoCreateFlag === 'Y' ? '활성' : '비활성' }}</el-form-item>
        <el-form-item label="자동생성 주기">{{ getAutoCreateData(reportBasicInfo) }}</el-form-item>
        <el-form-item label="보고서 수령 이메일">{{ getValueAfterCheckEmpty(reportBasicInfo.reportTargetEmail) }}</el-form-item>
      </el-form>
    </div>
    <div v-if="attrData.length > 0"  class="list form-list ">
      <div class="title-bar title-h4 tit">보고서 옵션</div>
      <el-form :model="reportOptionInfo" label-width="120px">
        <component v-for="(attr, index) in attrData" :class="attrData.length - 1 === index ? 'no-stroke' : ''" :key="attr.attrId" :is="getComponentName(attr)"
          :view-type="'INFO'"
          :default-set-list="getDefaultValue(attr.attrListSet)"
          :option-info="reportOptionInfo[attr.attrId]" />
      </el-form>
    </div>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import capitalize from 'lodash/capitalize';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import findIndex from 'lodash/findIndex';
import WDetailInfoComponent from '@/views/report/attr/DetailInfoComponent';
import WSortComponent from '@/views/report/attr/SortComponent';
import WWatchallGroupsTable from '@/views/report/attr/WatchallGroupsTable';
import WWatchallGroupTable from '@/views/report/attr/WatchallGroupTable';
import WWatchallObjsTree from '@/views/report/attr/WatchallObjsTree';
import WWatchallResourceComponent from '@/views/report/attr/WatchallResourceComponent';
import { getDateToString, getDate } from '@/utils/date';
import { TIME, MONTH, WEEK, INTERVAL_FIVE_MINUTE } from '@/constants/date';
import { getValueAfterCheckEmpty } from '@/utils/string';

export default {
  name: 'WReportInfoCheckView',
  components: {
    WDetailInfoComponent,
    WSortComponent,
    WWatchallGroupsTable,
    WWatchallGroupTable,
    WWatchallObjsTree,
    WWatchallResourceComponent,
  },
  props: {
    reportBasicInfo: {
      type: Object,
      default() {
        return {
          autoCreateFlag: 'N',
        };
      },
    },
    reportOptionInfo: {
      type: Object,
      default: () => {},
    },
    attrData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      periodType: {
        D: '일간',
        W: '주간',
        M: '월간',
        Q: '분기',
        H: '반기',
        Y: '연간',
        C: '사용자 정의',
      },
    };
  },
  methods: {
    getValueAfterCheckEmpty,
    getPeriodDate(periodConfSet) {
      if (isNil(periodConfSet)) {
        return '';
      }
      const periodDate = periodConfSet.split(',');
      const startTime = getDate(periodDate[0]);
      const endTime = getDate(periodDate[1]);
      return `${getDateToString(startTime)} ~ ${getDateToString(endTime)}`;
    },
    getAutoCreateData(basicInfo) {
      if (basicInfo.autoCreateFlag === 'N') {
        return getValueAfterCheckEmpty();
      }
      let autoCreateData = `${TIME[findIndex(TIME, ['time', basicInfo.autoCreateHour])].label}시 ${INTERVAL_FIVE_MINUTE[findIndex(INTERVAL_FIVE_MINUTE, ['minute', basicInfo.autoCreateMinute])].label} 분`;
      if (basicInfo.periodType === 'W') {
        autoCreateData = `${WEEK[findIndex(WEEK, ['week', basicInfo.autoCreateDay])].label} ${autoCreateData}`;
      } else if (basicInfo.periodType === 'M') {
        autoCreateData = `${basicInfo.autoCreateDate}일 ${autoCreateData}`;
      } else if (basicInfo.periodType !== 'D') {
        autoCreateData = `${basicInfo.autoCreateDate}일 ${autoCreateData}`;
        autoCreateData = `${MONTH[findIndex(MONTH, ['value', basicInfo.autoCreateMonth])].label} ${autoCreateData}`;
      }
      return autoCreateData;
    },
    /**
     * 템플릿 별 Attribute에 따른 ComponentName 반환
     * @author kimjy
     * @param  {Object} attr Attribute 정보
     * @return {String}      componentName
     */
    getComponentName(attr) {
      const componentNames = attr.attrId.split('_');
      let componentName = 'W';
      forEach(componentNames, (item) => {
        componentName = `${componentName}${capitalize(item)}`;
      });
      return `${componentName}${capitalize(attr.attrTypeId)}`;
    },
    /**
     * 기본 값 설정에 필요한 String 데이터 JSON 변환
     * @author kimjy
     * @param  {String} defaultValueStr 기본 설정 값
     */
    getDefaultValue(defaultValueStr) {
      if (!isEmpty(defaultValueStr)) {
        return JSON.parse(defaultValueStr);
      }
      return {};
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/report/popup/components/ReportInfoCheckView.vue